/**
 * returns start amount of subscribed people depending on hour
 * @param {Date} date - Current date time
 * @returns {number} - Initial subscribed people amount
 */
export const getSubscribedPeople = (date: Date): number => {
    let startAmount = 10;
    const hours = date.getHours();

    if (hours < 8 || hours >= 22) {
        startAmount = startAmount + 50 * hours;
    } else {
        startAmount = startAmount + 150 * hours;
    }

    return Math.floor(Math.random() * 100 + startAmount);
};
/**
 * adds depending on hour amount of subscribed people to current subscribed people amount
 * @param {Date} date - Current date time
 * @param {number} currentAmount - current subscribed people amount
 * @returns {number} - increased subscribed people amount
 */
export const increaseSubscribedPeople = (date: Date, currentAmount: number): number => {
    const hours = date.getHours();
    if (hours < 8) {
        return currentAmount + Math.floor(Math.random() * 2 + 1);
    } else if (hours < 22) {
        return currentAmount + Math.floor(Math.random() * 7 + 1);
    }
    return currentAmount + Math.floor(Math.random() * 3 + 1);
};
